import React from 'react';
import SuperPopup from '../SuperPopup';
import icon from '../../images/icons/ic-sports.svg';
import IcPlus from '../svg/IcPlus';
import IcCheckmark from '../svg/IcCheckmark';
import CompleteAccount from '../App/CompleteAccount';

import apiFetch from '../../src/js/fetch';
import { event } from '../../src/js/lib/plausible';

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      contestId: props.contest_id,
      joined: false,
      openCompleteAccount: false,
    };
  }

  join = async (e) => {
    const { contestId, processing } = this.state;

    if (processing) return;
    if (e?.target) {
      // If click on button, disable it to prevent multiple clicks.
      e.target.disabled = true;
    }

    this.setState({ processing: true });

    try {
      await apiFetch('/api/join-contest', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ contestId: contestId }),
      });

      // Track plausible event.
      event('Challenge - joined', {
        challenge: this.props.challenge,
      });

      // Open the modal.
      this.openModal();
    } catch (error) {
      const json = await error.json();
      console.log('Error joining:', error, json);

      if (json.error === 'missing_details') {
        // Show complete account modal.
        this.setState({ openCompleteAccount: true });
      } else {
        alert('Something went wrong. Please try again later.');
      }
    }
    this.setState({ processing: false });

    if (e?.target) {
      // If click on button, re-enable it
      e.target.disabled = false;
    }
  };

  openModal = (e) => {
    this.setState({
      open: true,
    });
  };

  closeModal = () => {
    this.setState({ open: false });

    // Global function to reload the leaderboard.
    if (window.reloadLeaderboard) {
      window.reloadLeaderboard();
    }

    this.setState({ joined: true });
  };

  inviteFriends = () => {
    // Close the modal.
    this.closeModal();

    // Open the invite friends modal.
    this.openInviteTrigger = document.querySelector('#open-invite');
    if (this.openInviteTrigger) {
      this.setState({ open: false }, () => {
        // This page has a button that the user can click to open the invite modal. Trigger a click on it.

        this.openInviteTrigger.click();
      });
    }
  };

  onCloseCompleteAccount = (completedNecessaryInfo) => {
    console.log('onCloseCompleteAccount');
    this.setState({ openCompleteAccount: false }, () => {
      if (completedNecessaryInfo) {
        // Retry joining the challenge.
        this.join();
      }
    });
  };

  render() {
    const { open, joined, openCompleteAccount } = this.state;
    return (
      <>
        {joined ? (
          <button className='button bordered mr-2'>
            Joined{' '}
            <span className='pl-2 svg-fill'>
              <IcCheckmark />
            </span>
          </button>
        ) : (
          <button onClick={this.join} className='button dark mr-2'>
            Join challenge{' '}
            <span className='pl-2 svg-fill'>
              <IcPlus />
            </span>
          </button>
        )}
        {openCompleteAccount && (
          <CompleteAccount
            challengeSignUp={true}
            onClose={this.onCloseCompleteAccount}
          />
        )}

        <SuperPopup
          open={open}
          onClose={this.closeModal}
          icon={icon}
          title="Great, you're in!"
          text="If you've already completed any of the segments within the challenge timeframe, we'll add your efforts to the leaderboard. You're still able to set a new best time within the challenge timeframe. Good luck!"
          buttons={[
            {
              text: 'Invite friends',
              onClick: this.inviteFriends,
              style: 'normal',
            },
            { text: 'Close', onClick: this.closeModal, style: 'dark' },
          ]}
        />
      </>
    );
  }
}

export default SignUp;
